import { useEffect } from 'react';
import { useUpdateNodeInternals, type NodeProps } from '@xyflow/react';
import BaseNode from './BaseNode';
import { type ActionNodeData } from '@app/services/aiFlow.types';

function ActionNode(props: NodeProps) {
    const { data, id } = props;
    const actionData = data as ActionNodeData;

    const updateNodeInternals = useUpdateNodeInternals();
    useEffect(() => {
        updateNodeInternals(id);
    }, [data.visConditionSlots, id, updateNodeInternals]);

    return (
        <BaseNode
            id={id}
            type="action"
            content={actionData.name}
            visConSlots={actionData.visConditionSlots}
        />
    );
}

export default ActionNode;
